import { KydActionStatusModel } from '../models/kyd-partial-household.model';
import {
  KydPartialHouseholdActions,
  KydPartialHouseholdActionTypes
} from './kyd-partial-household.actions';

export const KYD_PHH_KEY = 'kydPartialHousehold';

export interface KydPartialHouseholdState {
  actionStatus: KydActionStatusModel;
  loading: boolean;
  hasError: boolean;
  error: any;
}

export const initialState: KydPartialHouseholdState = {
  actionStatus: null,
  loading: false,
  hasError: false,
  error: null
};

export function reducer(
  state: KydPartialHouseholdState = initialState,
  action: KydPartialHouseholdActions
): KydPartialHouseholdState {
  switch (action.type) {
    case KydPartialHouseholdActionTypes.ResetState:
      return Object.assign({}, state, {
        actionStatus: null
      });

    case KydPartialHouseholdActionTypes.EnrollPolicy:
    case KydPartialHouseholdActionTypes.UnenrollPolicy:
    case KydPartialHouseholdActionTypes.EnrollOperator:
    case KydPartialHouseholdActionTypes.UnenrollOperator:
    case KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumber:
      return Object.assign({}, state, {
        actionStatus: null,
        loading: true
      });

    case KydPartialHouseholdActionTypes.EnrollPolicyAllOperatorsSuccess:
    case KydPartialHouseholdActionTypes.EnrollPolicySingleOperatorSuccess:
    case KydPartialHouseholdActionTypes.UnenrollPolicySuccess:
    case KydPartialHouseholdActionTypes.EnrollOperatorSuccess:
    case KydPartialHouseholdActionTypes.UnenrollOperatorSuccess:
    case KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumberSuccess:
      return Object.assign({}, state, {
        actionStatus: adaptActionType(action.type, action.payload),
        loading: false,
        hasError: false
      });

    case KydPartialHouseholdActionTypes.EnrollPolicyFail:
    case KydPartialHouseholdActionTypes.UnenrollPolicyFail:
    case KydPartialHouseholdActionTypes.EnrollOperatorFail:
    case KydPartialHouseholdActionTypes.UnenrollOperatorFail:
    case KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumberFail:
      const status: KydActionStatusModel = {
        recentAction: '',
        toastType: 'error',
        toastBody:
          'Oops, looks like something went wrong. To complete any KnowYourDrive changes, give us a call at 1-800-MYAMFAM (1-800-692-6326) or get in touch with your agent.'
      };
      return Object.assign({}, state, {
        actionStatus: status,
        loading: false,
        hasError: true,
        error: action.payload
      });

    default:
      return state;
  }
}

function adaptActionType(recentAction: string, operatorName?: string): KydActionStatusModel {
  switch (recentAction) {
    case KydPartialHouseholdActionTypes.EnrollPolicyAllOperatorsSuccess:
      return {
        recentAction: 'Enrolled All',
        toastType: 'success',
        toastBody: 'You’ve successfully enrolled all eligible drivers in KnowYourDrive!'
      };
    case KydPartialHouseholdActionTypes.EnrollOperatorSuccess:
    case KydPartialHouseholdActionTypes.EnrollPolicySingleOperatorSuccess:
      return {
        recentAction: 'Enrolled Operator',
        toastType: 'success',
        toastBody: 'You’ve successfully enrolled ' + operatorName + '!'
      };
    case KydPartialHouseholdActionTypes.UnenrollPolicySuccess:
      return {
        recentAction: 'Unenrolled All',
        toastType: 'success',
        toastBody: 'You’ve successfully unenrolled all drivers from KnowYourDrive.'
      };
    case KydPartialHouseholdActionTypes.UnenrollOperatorSuccess:
      return {
        recentAction: 'Unenrolled Operator',
        toastType: 'success',
        toastBody: 'You’ve successfully unenrolled ' + operatorName + '!'
      };
    case KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumberSuccess:
      return {
        recentAction: 'Phone Updated',
        toastType: 'success',
        toastBody: 'You’ve successfully updated a phone number.'
      };
    default:
      return null;
  }
}
